// Demo login is only available on Emergent preview / local, never on the live site.
export const DEMO_ENABLED = /(\.preview\.emergentagent\.com|^localhost)$/.test(window.location.hostname);
